(function (global) {
  global.foldercontent = {}

  /**
   * Выполняет прикладное действие над контентом папки.
   *
   * @function WebAccess.services.foldercontent.executeAction
   * @param  {string} actionName Имя действия.
   * @param  {Object} contents  Параметры контента.
   * @param  {string} contents.folderId ИД папки, над контентом которой совершается действие.
   * @param  {Array<Object>} [contents.selectedItems =[]] Список выделенных в папке элементов.
   * @param  {Array<Object>} [contents.unselectedItems = []] Список невыделенных в папке элементов.
   * @param  {boolean} contents.isAllItemsSelected Признак выделения всех объектов.
   * @param  {string} [contents.filter=''] Значение like-фильтра в папке.
   * @param  {Array<Object>} [contents.filterRequisites = ''] Реквизиты, по которым происходит фильтрация.
   * @param  {Object} [reinvokeCommand = {}] Параметры команд пост-обратотки действия.
   * @param  {number} [reinvokeCommand.commandNumber = 0] Номер команды пост-обработки действия.
   * @param  {number} [reinvokeCommand.commandType = 0] Тип команды пост-обработки действия.
   * @param  {Object} [reinvokeCommand.commandResult = 0] Результат выполнения команд пост-обработки действия.
   * @return {Deferred<Object>} Результат выполнения прикладного действия.
   * @since 5.6.0.1000
   * @see https://api.jquery.com/category/deferred-object/
   */
  global.foldercontent.executeAction = (actionName, contents, reinvokeCommand = {}) => {
    let d = $.Deferred();

    const service = '/api/FolderContent.asmx/ExecuteAction';
    let defaultContents = {
      selectedItems: [],
      unselectedItems: [],
      filter: '',
      filterRequisites: [],
    };
    let defaultreinvokeCommand = {
      commandNumber: 0,
      commandType: 0,
      commandResult: {},
    };
    contents = Object.assign(defaultContents, contents);
    reinvokeCommand = Object.assign(defaultreinvokeCommand, reinvokeCommand);
    let args = {
      actionName: actionName,
      contents: contents,
      reinvokeParameters: reinvokeCommand,
      };
    WA.SRV.call(service, args).done((res) => {
      d.resolve(res);
      }).fail((res) => {
      d.reject(res);
      });

    return d.promise();
      };

})(window.WebAccess.services);
